<template>

  <div id="app">

    <!-- Header -->
    <div class="col-12 bg-header">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-2 text-center">
            <img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/>
          </div>
          <div class="col-12 col-md-8 text-center">
            <h1>Online-Casino Vollmachtserteilung</h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Steps Overview -->
    <div class="container" v-if="!vm_erteilt">
      <div class="d-flex flex-row align-items-stretch">

        <div class="mb-0 text-white p-3 mr-2 flex-grow-1" v-bind:class="[ step === 1 ? 'bg-header' : 'bg-secondary' ]">
          <div class="font-weight-bold">Schritt 1</div>
          Angaben zu Ihrer Person
        </div>

        <div class="mb-0 text-white p-3 mr-2 flex-grow-1" v-bind:class="[ step === 2 ? 'bg-header' : 'bg-secondary' ]">
          <div class="font-weight-bold">Schritt 2</div>
          Angaben zu Casino(s)
        </div>

        <div class="mb-0 text-white p-3 mr-2 flex-grow-1" v-bind:class="[ step === 3 ? 'bg-header' : 'bg-secondary' ]">
          <div class="font-weight-bold">Schritt 3</div>
          Zustimmungen
        </div>

        <div class="mb-0 text-white p-3 flex-grow-1" v-bind:class="[ step === 4 ? 'bg-header' : 'bg-secondary' ]">
          <div class="font-weight-bold">Schritt 4</div>
          Vollmacht erteilen
        </div>

      </div>
    </div>

    <!-- Steps -->
    <div class="container mt-4">
      <div class="row">
        <div class="col-lg-12">
          <div class="border bg-white p-4" style="box-shadow: 0 0 25px rgba(0,0,0,0.1);">

            <div v-if="!vm_erteilt">

            <!-- Step 1 -->
            <div v-if="step === 1">
              <form class="mb-4" id="step_1">
                <input type="hidden" name="falldaten[session_token]" id="session_token" v-model="token"/>
                <p class="lead font-weight-bold">Angaben zu Ihrer Person</p>
                <div class="row">
                  <div class="col-12">
                    <div class="visible">
                      <div class="form-group">
                        <label>Anrede</label>
                        <div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="stammdaten[anrede]" value="Herr"
                                   id="anrede_1" v-model="stammdaten.anrede" required>
                            <label class="form-check-label" for="anrede_1">Herr</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="stammdaten[anrede]" value="Frau"
                                   id="anrede_2" v-model="stammdaten.anrede" required>
                            <label class="form-check-label" for="anrede_2">Frau</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                    <div class="visible">
                      <div class="form-group">
                        <label>Vorname</label>
                        <input
                            type="text"
                            name="stammdaten[vorname]"
                            id="vorname"
                            class="form-control"
                            v-model="stammdaten.vorname"
                            required/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                    <div class="visible">
                      <div class="form-group">
                        <label>Nachname</label>
                        <input
                            type="text"
                            name="stammdaten[nachname]"
                            id="nachname"
                            class="form-control"
                            v-model="stammdaten.nachname"
                            required/>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                    <div class="visible">
                      <div class="form-group">
                        <label>Straße und Nr.</label>
                        <input
                            type="text"
                            name="stammdaten[strasse]"
                            id="strasse"
                            class="form-control"
                            v-model="stammdaten.strasse"
                            required/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                    <div class="visible">
                      <div class="form-group">
                        <label>Postleitzahl</label>
                        <input
                            type="text"
                            name="stammdaten[plz]"
                            id="plz"
                            class="form-control"
                            v-model="stammdaten.plz"
                            required/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                    <div class="visible">
                      <div class="form-group">
                        <label>Ort</label>
                        <input
                            type="text"
                            name="stammdaten[ort]"
                            id="ort"
                            class="form-control"
                            v-model="stammdaten.ort"
                            required/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 mb-xl-0 col-lg-4 col-md-6 mb-3">
                    <div class="visible">
                      <div class="form-group">
                        <label>Geburtsdatum</label>
                        <input
                            type="text"
                            name="falldaten[geburtsdatum]"
                            id="geburtsdatum"
                            class="form-control"
                            v-model="falldaten.geburtsdatum"
                            required/>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="mb-4"></div>

                <div class="row">
                  <div class="col-lg-6 offset-lg-3 text-center mt-4">
                    <button type="submit" @click="nextStep" class="btn btn-dark btn-lg btn-block">
                      <i class="fa fa-arrow-right"></i> Weiter zu Schritt {{ step + 1 }}
                    </button>
                  </div>
                </div>

              </form>
            </div>

            <!-- Step 2 -->
            <div v-if="step === 2">
              <form class="mb-4" id="step_2">
                <p class="lead font-weight-bold">Angaben zu Casino(s)</p>

                <p>Bitte geben Sie hier alle Casinos an, bei denen Sie Verlust gemacht haben.</p>

                <button type="button" class="btn btn-sm btn-dark" @click="addCasino">+ Weiteres Casino hinzufügen
                </button>

                <div class="bg-light p-2 mt-3" v-for="(casino, index) in casinos" :key="casino.index"
                     style="border-top: solid 2px #003763">

                  <div class="font-weight-bold mb-4">
                    Casino {{ index + 1 }}
                    <span class="text-danger float-right">
                      <a @click="removeCasino(index)" href="#" class="text-danger"><i class="fa fa-trash"></i> Casino löschen</a>
                    </span>
                  </div>

                  <div class="row mb-2">
                    <div class="col-lg-5">
                      <label>Name des Casinos</label>
                    </div>
                    <div class="col-lg-7">
                      <input required class="form-control form-control-sm" v-model="casino.name"/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-lg-5">
                      <label>Benutzername des Benutzerkontos</label>
                    </div>
                    <div class="col-lg-7">
                      <input class="form-control form-control-sm" v-model="casino.benutzername"/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-lg-5">
                      <label>E-Mail-Adresse des Benutzerkontos</label>
                    </div>
                    <div class="col-lg-7">
                      <input type="email" required class="form-control form-control-sm" v-model="casino.email"/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-lg-5">
                      <label>In welchem Zeitraum haben Sie gespielt?</label>
                    </div>
                    <div class="col-lg-7">
                      <input required class="form-control form-control-sm" v-model="casino.zeitraum"/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-lg-5">
                      <label>Wie hoch war Ihr Verlust bei diesem Casino <span
                          class="font-weight-bold">circa</span>?</label>
                    </div>
                    <div class="col-lg-7">
                      <input required class="form-control form-control-sm" v-model="casino.forderungshoehe"/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-lg-5">
                      <label>Wussten Sie während des Spielens von der Illegalität?</label>
                    </div>
                    <div class="col-lg-7">
                      <select required class="custom-select custom-select-sm" v-model="casino.gewusst">
                        <option>Ja</option>
                        <option>Nein</option>
                      </select>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-lg-6 offset-lg-3 text-center mt-4">
                    <button :disabled="!casinos.length" type="submit" @click="nextStep" class="btn btn-dark btn-lg btn-block">
                      <i class="fa fa-arrow-right"></i> Weiter zu Schritt {{ step + 1 }}
                    </button>
                  </div>
                </div>

              </form>
            </div>

            <!-- Step 3 -->
            <div v-if="step === 3">
              <form class="mb-4" id="step_3">
                <p class="lead font-weight-bold">Ihre Zustimmungen</p>

                <p>Für eine Bevollmächtigung müssen Sie den folgenden 6 Punkten zustimmen.</p>

                <div class="">

                  <div class="row border-bottom pb-3 mb-3">
                    <div class="col-lg-9">
                      <p class="mb-1 font-weight-bold">Ich hatte keine Kenntnis über die Illegalität des / der Casinos
                        Angebots:</p>
                    </div>
                    <div class="col-lg-3 text-right">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_eins" id="z1a" value="1">
                        <label class="form-check-label" for="z1a">
                          Stimmt
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_eins" id="z1b" value="">
                        <label class="form-check-label" for="z1b">
                          Stimmt nicht
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row border-bottom pb-3 mb-3">
                    <div class="col-lg-9">
                      <p class="mb-1 font-weight-bold">Ich habe keinen anderen Rechtsanwalt mit der Geltendmachung der hier gegenständlichen Forderungen beauftragt:</p>
                    </div>
                    <div class="col-lg-3 text-right">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_zwei" id="z2a" value="1">
                        <label class="form-check-label" for="z2a">
                          Stimmt
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_zwei" id="z2b" value="">
                        <label class="form-check-label" for="z2b">
                          Stimmt nicht
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row border-bottom pb-3 mb-3">
                    <div class="col-lg-9">
                      <p class="mb-1 font-weight-bold">Ich habe keinen anderen Prozeßkostenfinanzierer mit der Geltendmachung der hier gegenständlichen Forderungen beauftragt:</p>
                    </div>
                    <div class="col-lg-3 text-right">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_drei" id="z3a" value="1">
                        <label class="form-check-label" for="z3a">
                          Stimmt
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_drei" id="z3b" value="">
                        <label class="form-check-label" for="z3b">
                          Stimmt nicht
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row border-bottom pb-3 mb-3">
                    <div class="col-lg-9">
                      <p class="mb-1 font-weight-bold">Die Betreiberin des Casinos hat keine Gegenrechte gegen mich, z.B Aufrechnung, Zurückbehaltungsrechte, oder sonstige entgegenstehende Rechte:</p>
                    </div>
                    <div class="col-lg-3 text-right">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_vier" id="z4a" value="1">
                        <label class="form-check-label" for="z4a">
                          Stimmt
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_vier" id="z4b" value="">
                        <label class="form-check-label" for="z4b">
                          Stimmt nicht
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row border-bottom pb-3 mb-3">
                    <div class="col-lg-9">
                      <p class="mb-1 font-weight-bold">Ich bin im Hinblick auf die hier gegenständlichen Ansprüche verfügungsberechtigt, das heißt die Ansprüche wurden bisher nicht abgetreten, verpfändet, gepfändet und sind auch sonst nicht mit Rechten Dritter belastete:</p>
                    </div>
                    <div class="col-lg-3 text-right">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_fuenf" id="z5a" value="1">
                        <label class="form-check-label" for="z5a">
                          Stimmt
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_fuenf" id="z5b" value="">
                        <label class="form-check-label" for="z5b">
                          Stimmt nicht
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row border-bottom pb-3 mb-3">
                    <div class="col-lg-9">
                      <p class="mb-1 font-weight-bold">Ich befinde mich nicht in der Privatinsolvenz und es droht keine Privatinsolvenz:</p>
                    </div>
                    <div class="col-lg-3 text-right">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_sechs" id="z6a" value="1">
                        <label class="form-check-label" for="z6a">
                          Stimmt
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="zustimmung_sechs" id="z6b" value="">
                        <label class="form-check-label" for="z6b">
                          Stimmt nicht
                        </label>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-lg-6 offset-lg-3 text-center mt-4">
                    <button :disabled="!zustimmung_eins || !zustimmung_zwei || !zustimmung_drei || !zustimmung_vier || !zustimmung_fuenf || !zustimmung_sechs" type="submit" @click="nextStep" class="btn btn-dark btn-lg btn-block">
                      <i class="fa fa-arrow-right"></i> Weiter zu Schritt {{ step + 1 }}
                    </button>
                  </div>
                </div>

              </form>
            </div>

            <!-- Step 4 -->
            <div v-if="step === 4">
              <form class="mb-4" id="step_4">
                <p class="lead font-weight-bold">Vollmacht erteilen</p>

                <p>Bitte unterschreiben Sie mit Ihrer Maus oder Ihrem Finger die nachfolgende Vollmacht
                  über das Unterschriftenfeld am Ende der Seite . Im Anschluss können Sie unsere Online-Volmacht
                  absenden.</p>

                <hr/>

                <p>Hiermit erteile ich der <strong>VON RUEDEN Rechtsanwälten PartG</strong>, Leipziger Platz 9, 10117
                  Berlin, wegen
                  aller in Betracht kommenden Spielverluste bei Online-Casinos und/oder Wettanbietern Vollmacht zur
                  außergerichtlichen Vertretung aller Art als auch Prozessvollmacht für alle Verfahren in allen
                  Instanzen gegen alle in Frage kommenden Gegner.</p>

                <p>Der Bevollmächtigte ist zur Übertragung dieser Vollmacht ganz oder teilweise befugt.
                <p>Diese Vollmacht erstreckt sich insbesondere auf:</p>
                <ul>
                  <li>1. die außergerichtliche Vertretung,</li>
                  <li>2. die Begründung und Aufhebung von Vertragsverhältnissen, die Abgabe und Entgegennahme
                    von einseitigen Willenserklärungen in jedem Verfahren sowie in außergerichtlichen
                    Verhandlungen, insbesondere zur Beauftragung von Prozessfinanzierern,
                  </li>
                  <li>3. die Prozessführung sowie die Vertretung in sonstigen Verfahren, insbesondere vor Behörden,
                    einschließlich der Vorverfahren und der verwaltungsgerichtlichen Verfahren sowie die
                    Empfangnahme von Schriftstücken, sonstigem Schriftverkehr sowie aller Gelder.
                    Der vorgenannte Vertreter ist umfassend unterrichtet, zur Aufklärung des Tatbestandes in der Lage
                    und zur Abgabe der gebotenen Erklärungen, insbesondere zu einem Vergleichsabschluss ermächtigt.
                  </li>
                </ul>

                <div class="visible">
                  <div class="form-group">
                    <strong>Unterschrift</strong>
                    <div class="mb-2">
                      <div class="bg-white mb-2 my-3">
                        <div style="max-width:420px;">
                          <div style="border: solid 1px #ddd; margin-bottom: 10px;">
                            <VueSignaturePad width="380px" height="200px" ref="signaturePad" :options="{onEnd}"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="cursor-pointer" id="remove_signature" @click="clearSignature()">
                      <i class="fa fa-trash text-danger"></i> Unterschrift erneut eingeben
                    </div>
                    <textarea style="display:none" name="falldaten[unterschrift]" id="unterschrift"></textarea>
                  </div>
                </div>

                <div class="mb-4"></div>

                <div class="row">
                  <div class="col-lg-6 offset-lg-3 text-center mt-4">
                    <button type="submit" @click="submitVollmacht" class="btn btn-dark btn-lg btn-block">
                      <i class="fa fa-arrow-right"></i> Vollmacht jetzt erteilen
                    </button>
                  </div>
                </div>

              </form>
            </div>

            </div>

            <div v-else>

              <h2>Vielen Dank</h2>

              <p>Ihre Online-Vollmacht wurde übermittelt.</p>

              <p>Bitte senden Sie nun noch die nachfolgende DSGVO-Abfrage an die von
              Ihnen angegebenen Glückspielanbieter:</p>

              <strong>Link:</strong> <a href="https://www.rueden.de/textvorlage-dsgvo-abfrage-online-casino/">Zur DSGVO Abfrage</a>

            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-3">
      <div class="small mt-3"><i class="fa fa-lock text-warning"></i>
        Sichere Datenübertragung dank SSL-Verschlüsselung.
      </div>
      <div class="small">&copy; 2022 | <a href="https://www.rueden.de" target="_blank" class="text-dark">Impressum</a></div>
    </div>

  </div>

</template>
<script>

import axios from 'axios'
//import Schrittanzeige from '../../components/filesharing/Schrittanzeige'
//import Datenschutzerklaerung from '../Datenschutzerklaerung'
//import Widerrufsbelehrung from '../Widerrufsbelehrung'

export default {

  components: {
    //Schrittanzeige,
    //Datenschutzerklaerung,
    //Widerrufsbelehrung
  },

  data() {

    return {

      token: "",
      step: 1,

      stammdaten: {
        anrede: "",
        vorname: "",
        nachname: "",
        strasse: "",
        plz: "",
        ort: ""
      },

      falldaten: {
        unterschrift: "",
        session_token: "",
        geburtsdatum: ""
      },

      zustimmung_eins: "",
      zustimmung_zwei: "",
      zustimmung_drei: "",
      zustimmung_vier: "",
      zustimmung_fuenf: "",
      zustimmung_sechs: "",

      vm_erteilt: false,

      casinos: [
        {
          name: "",
          benutzername: "",
          email: "",
          zeitraum: "",
          forderungshoehe: "",
          gewusst: ""
        }
      ]

    }
  },

  mounted() {

    document.title = 'Vollmachtserteilung - Online Casino';
    this.$global.gaCat = 'Vollmachtserteilung - Online Casino';

    // URL der API
    let token = this.$route.query.token;

    // API
    this.api = "https://flow.rueden.de/api/get/lead/" + token;

    if (token === '' || token === undefined) {
      window.location.href = "https://www.rueden.de";
    } else {
      this.token = token;
      this.falldaten.session_token = token;
    }

    // Get Lead from Flow
    this.getLead();

  },
  methods: {

    nextStep(e) {

      if (this.step === 1) {
        if (document.getElementById("step_1")) {
        if (document.getElementById("step_1").checkValidity()) {
          e.preventDefault();
          this.step += 1;
        }
        }
      }

      if (this.step === 2) {
        if (document.getElementById("step_2")) {
        if (document.getElementById("step_2").checkValidity()) {
          e.preventDefault();
          this.step += 1;
        }
        }
      }

      if (this.step === 3) {
        if (document.getElementById("step_3")) {
          if (document.getElementById("step_3").checkValidity()) {
            e.preventDefault();
            this.step += 1;
          }
        }
      }

    },

    addCasino() {
      this.casinos.push({})
    },

    removeCasino(array_index) {
      this.casinos.splice(array_index, 1)
    },

    getLead() {
      let url = 'https://flow.rueden.de/api/get/lead/' + this.token;

      let _this = this;
      axios.get(url)
          .then((response) => {
            let lead = response.data;
            _this.stammdaten.anrede = lead.anrede;
            _this.stammdaten.vorname = lead.vorname;
            _this.stammdaten.nachname = lead.nachname;
            _this.stammdaten.strasse = lead.strasse;
            _this.stammdaten.plz = lead.plz;
            _this.stammdaten.ort = lead.ort;
            _this.falldaten.geburtsdatum = lead.geburtsdatum
            _this.vm_erteilt = lead.vm_erteilt;
          })
          .then(function () {
            // Zu Schritt 2 gehen, wenn Stammdaten vollständig
            if (_this.stammdaten.anrede &&
                _this.stammdaten.vorname &&
                _this.stammdaten.nachname &&
                _this.stammdaten.strasse &&
                _this.stammdaten.plz &&
                _this.stammdaten.ort &&
                _this.falldaten.geburtsdatum) {
              //_this.step = 2
            }
          })
    },

    submitVollmacht(e) {

      e.preventDefault();

      if (!this.falldaten.unterschrift) {
        alert('Bitte unterschreiben Sie die Vollmacht.')
        return false;
      }

      let _this = this;

      fetch("https://flow.rueden.de/api/update/lead/onlinecasino", {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body:
            JSON.stringify({
              token: _this.token,
              stammdaten: _this.stammdaten,
              falldaten: _this.falldaten,
              casinos: _this.casinos
            })
      })
          .then(response => response.json())
          .then(data => {
            _this.vm_erteilt = true
            console.log(data)
          })

    },

    // Signature

    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.falldaten.unterschrift = this.$refs.signaturePad.saveSignature().data;
    },

    onEnd() {
      this.falldaten.unterschrift = this.$refs.signaturePad.saveSignature().data;
    },

    undo() {
      this.$refs.signaturePad.undoSignature();
    },

    save() {
      this.$refs.signaturePad.saveSignature();
      //const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
      //console.log(isEmpty);
      //console.log(data);
    },

  }

}

</script>
